import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "cart-item-options"
};
const _hoisted_2 = {
  key: 0,
  class: "item-po-wrapper"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["aria-label", "placeholder"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "options-right"
};
const _hoisted_7 = {
  class: "po-label"
};
const _hoisted_8 = {
  class: "po-num"
};
const _hoisted_9 = ["aria-label"];
const _hoisted_10 = ["aria-label"];
const _hoisted_11 = {
  class: "cart-item-header"
};
const _hoisted_12 = {
  class: "cart-item-header-icon"
};
const _hoisted_13 = {
  class: "cart-item-header-info"
};
const _hoisted_14 = {
  key: 0,
  class: "cart-item-header-info-container"
};
const _hoisted_15 = {
  class: "cart-item-header-info-container-name notranslate"
};
const _hoisted_16 = {
  key: 1,
  class: "cart-item-header-info-container-name notranslate"
};
const _hoisted_17 = {
  key: 2,
  class: "cart-item-header-info-container cart-push-right"
};
const _hoisted_18 = {
  class: "cart-item-header-info-container-number cart-push-right"
};
const _hoisted_19 = {
  class: "notranslate"
};
const _hoisted_20 = {
  key: 3,
  class: "cart-item-header-info-container-number cart-push-right"
};
const _hoisted_21 = {
  class: "notranslate"
};
const _hoisted_22 = {
  class: "cart-item-body"
};
const _hoisted_23 = {
  class: "cart-item-body-info-container"
};
const _hoisted_24 = {
  class: "unit-price"
};
const _hoisted_25 = {
  class: "cart-item-body-info-container-title"
};
const _hoisted_26 = {
  key: 0,
  class: "cart-item-body-info-container-unconfigured"
};
const _hoisted_27 = {
  key: 1,
  class: "cart-item-quantity-display"
};
const _hoisted_28 = {
  key: 0,
  class: "cart-item-body-info-container-title"
};
const _hoisted_29 = {
  key: 1,
  class: "cart-item-body-info-container-title"
};
const _hoisted_30 = {
  key: 2,
  class: "cart-item-body-info-container-unconfigured"
};
const _hoisted_31 = {
  class: "cart-item-requested-date-icon"
};
const _hoisted_32 = {
  class: "cart-item-requested-date-text"
};
const _hoisted_33 = {
  key: 4,
  class: "cart-item-requested-date-pending"
};
const _hoisted_34 = {
  class: "cart-item-body-info-container"
};
const _hoisted_35 = {
  class: "unit-price"
};
const _hoisted_36 = {
  class: "cart-item-body-info-container-title"
};
const _hoisted_37 = {
  key: 0,
  class: "cart-item-body-info-container-unconfigured"
};
const _hoisted_38 = {
  class: "cart-item-body-info-container"
};
const _hoisted_39 = {
  class: "cart-item-body-info-container-title"
};
const _hoisted_40 = {
  key: 0,
  class: "cart-item-body-info-container-unconfigured"
};
const _hoisted_41 = {
  key: 2,
  class: "cart-item-body-info-container exchange-rate"
};
const _hoisted_42 = {
  class: "cart-item-body-info-container-title"
};
const _hoisted_43 = {
  class: "cart-item-body-info-container-body"
};
const _hoisted_44 = {
  key: 0,
  class: "cart-item-body-info-container"
};
const _hoisted_45 = {
  class: "cart-item-body-info-container-title"
};
const _hoisted_46 = {
  class: "cart-item-body-info-container-body"
};
const _hoisted_47 = {
  key: 0,
  class: "cart-item-body-arrow"
};
const _hoisted_48 = ["aria-label", "title"];
const _hoisted_49 = ["aria-label", "title"];
const _hoisted_50 = ["aria-label"];
const _hoisted_51 = ["aria-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BundleIcon = _resolveComponent("BundleIcon");
  const _component_ProductBox = _resolveComponent("ProductBox");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_ThreeDots = _resolveComponent("ThreeDots");
  const _component_CheckmarkIcon = _resolveComponent("CheckmarkIcon");
  const _component_ChevronIcon = _resolveComponent("ChevronIcon");
  const _component_AdditionalDetails = _resolveComponent("AdditionalDetails");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!$props.isCheckoutPage ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", {
    innerHTML: $options.getI18nMessage('text.search.option.poNo')
  }, null, 8, _hoisted_3), _withDirectives(_createElementVNode("input", {
    "aria-label": $options.getI18nMessage('checkout.payment.PONumber.enterPONumber'),
    tabindex: "0",
    type: "text",
    placeholder: $options.getI18nMessage('checkout.payment.PONumber.enterPONumber'),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.itemData.poNumber = $event),
    class: _normalizeClass({
      'invalid': $props.itemData.isPoInvalid
    }),
    onFocus: _cache[1] || (_cache[1] = (...args) => $options.clearUpdateTimeout && $options.clearUpdateTimeout(...args)),
    onBlur: _cache[2] || (_cache[2] = $event => $options.updateItemPO($props.itemData))
  }, null, 42, _hoisted_4), [[_vModelText, $props.itemData.poNumber]]), _withDirectives(_createElementVNode("p", {
    class: "error-message",
    innerHTML: $options.getI18nMessage('quickOrder.PO.error')
  }, null, 8, _hoisted_5), [[_vShow, $props.itemData.isPoInvalid]])])) : _createCommentVNode("", true), $props.isCheckoutPage ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString($options.getI18nMessage('text.search.option.poNo')), 1), _createElementVNode("span", _hoisted_8, _toDisplayString($props.itemData.lineItemPO), 1)])) : _createCommentVNode("", true), !$props.isCheckoutPage && !$data.moveEditRemove ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    href: "#",
    class: "cart-item-options-link",
    "aria-label": $options.getI18nMessage('button.edit.UPPER'),
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.editItem(), ["prevent"])),
    onKeydown: _cache[4] || (_cache[4] = _withKeys($event => $options.editItem(), ["enter"]))
  }, _toDisplayString($options.getI18nMessage('button.edit.UPPER')), 41, _hoisted_9)) : _createCommentVNode("", true), !$props.isCheckoutPage && !$data.moveEditRemove ? (_openBlock(), _createElementBlock("a", {
    key: 3,
    href: "#",
    class: "cart-item-options-link",
    "aria-label": $options.getI18nMessage('remove.UPPER'),
    onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.emitRemoveItemModal($props.itemData), ["prevent"])),
    onKeydown: _cache[6] || (_cache[6] = _withKeys(event => {
      event.preventDefault();
      event.stopPropagation();
      $options.emitRemoveItemModal($props.itemData);
    }, ["enter"]))
  }, _toDisplayString($options.getI18nMessage('remove.UPPER')), 41, _hoisted_10)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: _normalizeClass(["cart-item", {
      'cart-item-unconfigured': $props.isUnconfiguredEntry,
      'cart-item-remove': $props.isNeedRemoveEntry || $props.isNeedEditEntry && !$props.isUnconfiguredEntry || $props.itemData.isUnconfirmedItem
    }])
  }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [$props.itemData.isBundled ? (_openBlock(), _createBlock(_component_BundleIcon, {
    key: 0,
    class: "cart-item-header-icon-bundled"
  })) : (_openBlock(), _createBlock(_component_ProductBox, {
    key: 1
  }))]), _createElementVNode("div", _hoisted_13, [$props.itemData.myPartDescription ? (_openBlock(), _createElementBlock("span", _hoisted_14, [_createElementVNode("h3", _hoisted_15, _toDisplayString($props.itemData.myPartDescription), 1), _createVNode(_component_Tooltip, {
    notranslate: true,
    passedText: $props.itemData.salesText
  }, null, 8, ["passedText"])])) : (_openBlock(), _createElementBlock("h3", _hoisted_16, _toDisplayString($props.itemData.salesText), 1)), $props.itemData.myPartNumber ? (_openBlock(), _createElementBlock("span", _hoisted_17, [_createElementVNode("p", _hoisted_18, [_createTextVNode(_toDisplayString($options.getI18nMessage('part.no.Title')) + " ", 1), _createElementVNode("span", _hoisted_19, _toDisplayString($props.itemData.myPartNumber), 1)]), _createVNode(_component_Tooltip, {
    notranslate: true,
    passedText: $options.getI18nMessage('material.no.Title') + $props.itemData.materialNumber
  }, null, 8, ["passedText"])])) : (_openBlock(), _createElementBlock("p", _hoisted_20, [_createTextVNode(_toDisplayString($options.getI18nMessage('material.no.Title')) + " ", 1), _createElementVNode("span", _hoisted_21, _toDisplayString($props.itemData.materialNumber), 1)]))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    class: _normalizeClass(["cart-item-body-info", $props.itemData?.shipMode ? 'shipModeCol' : ''])
  }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("p", _hoisted_25, _toDisplayString($options.getI18nMessage('availability.quantity.label')), 1)]), $props.isUnconfiguredEntry ? (_openBlock(), _createElementBlock("p", _hoisted_26, " -- ")) : (_openBlock(), _createElementBlock("span", _hoisted_27, [_createElementVNode("p", {
    class: _normalizeClass(["cart-item-body-info-container-body", {
      'cart-item-body-info-container-remove': $props.isNeedRemoveEntry || $props.isNeedEditEntry
    }])
  }, _toDisplayString($props.itemData.displayQuantity ? $options.getFormattedQuantity($props.itemData.displayQuantity, $props.itemData.salesUnitSapName) : $options.getFormattedQuantity($props.itemData.quantity, $props.itemData.salesUnitSapName)), 3), $options.showQuantityTooltip() ? (_openBlock(), _createBlock(_component_Tooltip, {
    key: 0,
    class: "cart-item-body-info-container-tooltip",
    passedText: $options.quantityTooltipText(),
    tabindex: "0",
    "aria-label": $options.quantityTooltipText()
  }, null, 8, ["passedText", "aria-label"])) : _createCommentVNode("", true)]))]), _createElementVNode("div", {
    class: _normalizeClass(["cart-item-body-info-container cart-item-requested-date", {
      'is-non-real-time': $props.itemData.nonRealTime
    }])
  }, [$props.itemData.shipCondition == '02' || $props.itemData.shipCondition == '19' ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($options.getI18nMessage('pickup.date.Title')), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($options.getI18nMessage('requested.delivery.date')), 1)), $props.isUnconfiguredEntry ? (_openBlock(), _createElementBlock("p", _hoisted_30, " -- ")) : (_openBlock(), _createElementBlock("p", {
    key: 3,
    class: _normalizeClass(["cart-item-body-info-container-body", {
      'cart-item-body-info-container-remove': $props.isNeedRemoveEntry || $props.isNeedEditEntry
    }])
  }, [_createElementVNode("span", _hoisted_31, [$props.itemData.nonRealTime ? (_openBlock(), _createBlock(_component_ThreeDots, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_CheckmarkIcon, {
    key: 1
  }))]), _createElementVNode("span", _hoisted_32, _toDisplayString($options.getFormattedDate($props.itemData.deliveryDate)), 1)], 2)), $props.itemData.nonRealTime ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString($props.itemData.shipCondition == '02' || $props.itemData.shipCondition == '19' ? $options.getI18nMessage('pickup.date.pending') : $options.getI18nMessage('delivery.date.pending')), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("p", _hoisted_36, _toDisplayString($options.getI18nMessage('cart.page.line.item.unitPrice')) + " " + _toDisplayString($options.ltlSurchargeLabel($props.itemData)), 1), $props.itemData.isBundled ? (_openBlock(), _createBlock(_component_Tooltip, {
    key: 0,
    passedText: $props.isCheckoutPage ? $options.getI18nMessage('product.family.pricing.active.Title') : $options.getI18nMessage('cartitem.product.pricing.active.Title'),
    tabindex: "0",
    "aria-label": $props.isCheckoutPage ? $options.getI18nMessage('product.family.pricing.active.Title') : $options.getI18nMessage('cartitem.product.pricing.active.Title')
  }, null, 8, ["passedText", "aria-label"])) : _createCommentVNode("", true)]), $props.isUnconfiguredEntry ? (_openBlock(), _createElementBlock("p", _hoisted_37, " -- ")) : (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: _normalizeClass(["cart-item-body-info-container-body", {
      'cart-item-body-info-container-remove': $props.isNeedRemoveEntry || $props.isNeedEditEntry
    }])
  }, _toDisplayString($options.getUnitPrice($props.itemData)) + " " + _toDisplayString($props.itemData.currencyIso) + " / " + _toDisplayString($props.itemData.priceUnitSapName), 3))]), _createElementVNode("div", _hoisted_38, [_createElementVNode("p", _hoisted_39, _toDisplayString($options.getI18nMessage('cart.page.line.item.amount')) + " " + _toDisplayString($options.ltlSurchargeLabel($props.itemData)), 1), $props.isUnconfiguredEntry ? (_openBlock(), _createElementBlock("p", _hoisted_40, " -- ")) : (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: _normalizeClass(["cart-item-body-info-container-body", {
      'cart-item-body-info-container-remove': $props.isNeedRemoveEntry || $props.isNeedEditEntry
    }])
  }, _toDisplayString($options.getTotalPrice($props.itemData)) + " " + _toDisplayString($props.itemData.currencyIso), 3)), $props.itemData.exchangeRate > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("p", _hoisted_42, _toDisplayString($options.getI18nMessage('return.details.page.net.valueExchangerate')), 1), _createElementVNode("p", _hoisted_43, _toDisplayString($options.getFormattedNumber($props.itemData.exchangeRate)), 1)])) : _createCommentVNode("", true)]), $props.itemData?.shipMode ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("p", _hoisted_45, _toDisplayString($options.getI18nMessage('cart.page.line.item.modeOfTransport')), 1), _createElementVNode("p", _hoisted_46, _toDisplayString($options.geti18nDisplayValue($props.itemData.shipMode)), 1)])) : _createCommentVNode("", true)], 2), !$data.moveEditRemove ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("a", {
    href: "#",
    onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => $options.toggleDetails && $options.toggleDetails(...args), ["prevent"])),
    class: _normalizeClass(["cart-item-trigger", {
      'is-open': $data.showDetails
    }]),
    "aria-label": $data.showDetails ? $options.getI18nMessage('collapse') : $options.getI18nMessage('expand'),
    title: $data.showDetails ? $options.getI18nMessage('collapse') : $options.getI18nMessage('expand')
  }, [_createVNode(_component_ChevronIcon)], 10, _hoisted_48)])) : _createCommentVNode("", true)]), $data.showDetails ? (_openBlock(), _createBlock(_component_AdditionalDetails, {
    key: 0,
    item: $props.itemData,
    isMultiPo: $props.isMultiPo,
    shipToCountry: $props.shipToCountry,
    isCheckout: $props.isCheckoutPage
  }, null, 8, ["item", "isMultiPo", "shipToCountry", "isCheckout"])) : _createCommentVNode("", true), !$data.moveEditRemove ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    href: "#",
    onClick: _cache[8] || (_cache[8] = _withModifiers((...args) => $options.toggleDetails && $options.toggleDetails(...args), ["prevent"])),
    class: _normalizeClass(["cart-item-trigger-mobile", {
      'is-open': $data.showDetails
    }]),
    "aria-label": $data.showDetails ? $options.getI18nMessage('collapse') : $options.getI18nMessage('expand'),
    title: $data.showDetails ? $options.getI18nMessage('collapse') : $options.getI18nMessage('expand')
  }, [_createTextVNode(_toDisplayString($data.showDetails ? $options.getI18nMessage('hide.item.details') : $options.getI18nMessage('view.item.details')) + " ", 1), _createVNode(_component_ChevronIcon)], 10, _hoisted_49)) : _createCommentVNode("", true), $data.moveEditRemove ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["cart-item-footer-container", {
      'cart-item-footer-container-red-border': $props.isNeedRemoveEntry || $props.isNeedEditEntry && !$props.isUnconfiguredEntry,
      'cart-item-footer-container-yellow-border': $props.isUnconfiguredEntry
    }])
  }, [$props.isUnconfiguredEntry || $props.isNeedEditEntry ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: _normalizeClass(["cart-item-footer-container-button-1", {
      'cart-item-footer-container-button-1-red': $props.isNeedEditEntry,
      'cart-item-footer-container-button-1-yellow': $props.isUnconfiguredEntry
    }]),
    "aria-label": $options.getI18nMessage('cart.page.item.edit.label'),
    onClick: _cache[9] || (_cache[9] = $event => $options.editItem()),
    onKeydown: _cache[10] || (_cache[10] = _withKeys($event => $options.editItem(), ["enter"]))
  }, _toDisplayString($options.getI18nMessage('cart.page.item.edit.label')), 43, _hoisted_50)) : _createCommentVNode("", true), _createElementVNode("button", {
    type: "button",
    class: _normalizeClass({
      'cart-item-footer-container-button-1 cart-item-footer-container-button-1-red': $props.isNeedRemoveEntry,
      'cart-item-footer-container-button-2 cart-item-footer-container-button-2-yellow': $props.isUnconfiguredEntry,
      'cart-item-footer-container-button-2 cart-item-footer-container-button-2-red': $props.isNeedEditEntry
    }),
    "aria-label": $options.getI18nMessage('remove.UPPER'),
    onClick: _cache[11] || (_cache[11] = $event => $options.emitRemoveItemModal($props.itemData)),
    onKeydown: _cache[12] || (_cache[12] = _withKeys(event => {
      event.preventDefault();
      event.stopPropagation();
      $options.emitRemoveItemModal($props.itemData);
    }, ["enter"]))
  }, _toDisplayString($options.getI18nMessage('remove.UPPER')), 43, _hoisted_51)], 2)) : _createCommentVNode("", true)], 2)], 64);
}